import { render, staticRenderFns } from "./form-section-intake-step-2.vue?vue&type=template&id=22cdc9f0&scoped=true"
import script from "./form-section-intake-step-2.vue?vue&type=script&lang=js"
export * from "./form-section-intake-step-2.vue?vue&type=script&lang=js"
import style0 from "./form-section-intake-step-2.vue?vue&type=style&index=0&id=22cdc9f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cdc9f0",
  null
  
)

export default component.exports